// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: var(--background-default);
}

.wrapper {
  padding: 24px 16px;
  padding-bottom: 60px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: transparent;
}
.wrapper .title {
  font-family: AppFontSemiBold;
  font-size: 16px;
  margin: 0;
  display: flex;
  align-items: center;
  color: var(--color-black);
  text-transform: capitalize;
  text-align: start;
  padding: 0px 0px 16px;
}
.wrapper ion-col {
  padding: 0;
}
.wrapper ion-col:not(:last-child) {
  margin-bottom: 6px;
}
.wrapper ion-col .card-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: var(--outline-default);
  border-radius: var(--radius-default);
  height: 100%;
  padding: 8px;
}
.wrapper ion-col .card-item .default-img {
  padding: 5px;
  object-fit: contain !important;
  background-color: #fff;
}
.wrapper ion-col .card-item .image-block {
  height: 60px;
  aspect-ratio: 4/3;
  position: relative;
  margin-right: 16px;
}
.wrapper ion-col .card-item .image-block ion-img {
  width: 100%;
  height: 100%;
}
.wrapper ion-col .card-item .image-block .plus {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 32px;
  width: 32px;
}
.wrapper ion-col .card-item .info-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-grow: 1;
  padding-right: 5px;
}
.wrapper ion-col .card-item .info-block .name {
  font-family: AppFontMedium;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.01em;
  margin: 0 0 4px;
  display: flex;
  align-items: center;
  color: #1e1e1c;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrapper ion-col .card-item .info-block .deposit_text {
  font-size: 9px;
  font-family: AppFont, sans-serif;
  color: var(--color-black);
  margin: 0;
  margin-top: 20px;
  text-align: center;
}
.wrapper ion-col .card-item .info-block .price {
  margin: auto 0 10px;
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 21.8px;
  letter-spacing: 0.01em;
  text-align: center;
  color: #1e1e1c;
}
.wrapper ion-col .card-item .button {
  background: #f5f5f5;
  height: 39px;
  width: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  font-family: AppFont;
  font-size: 14px;
  text-align: center;
  color: var(--color-black);
  border-radius: 3px;
}
.wrapper .selected .checkmark {
  display: block;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  --icon-color: var(--ion-color-primary);
}
.wrapper .selected .card-item .button {
  --background: var(--ion-color-secondary) !important;
  background: var(--background) !important;
  color: var(--ion-color-secondary-contrast);
  font-size: 12px;
}

.content_block {
  height: calc(100% - 74px);
  overflow-y: auto;
  width: 100%;
}

.footer-btn {
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 16px;
}
.footer-btn ion-button {
  width: 100%;
  --background: transparent;
  font-family: AppFont;
  color: #1d1d1b !important;
  border: 0.6px solid #aeaead;
  border-radius: var(--radius-default);
  font-size: 14px;
  line-height: 18.9px;
  letter-spacing: 0.03em;
  text-align: center;
}
.footer-btn ion-button.selected {
  --background: var(--ion-color-primary) !important;
  background: var(--background) !important;
  border: 0.6px solid var(--background);
  font-family: AppFontBold;
  color: var(--color-white) !important;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: left;
  padding-top: 6px;
}

.checkmark {
  height: 18px;
  width: 18px;
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,qCAAA;AADD;;AAIA;EACC,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;AADD;AAGC;EACC,4BAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;EAEA,iBAAA;EACA,qBAAA;AAFF;AAIC;EACC,UAAA;AAFF;AAIE;EACC,kBAAA;AAFH;AAKE;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,oCAAA;EAEA,YAAA;EACA,YAAA;AAJH;AAMG;EACC,YAAA;EACA,8BAAA;EACA,sBAAA;AAJJ;AAOG;EACC,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AALJ;AAWI;EACC,WAAA;EACA,YAAA;AATL;AAWI;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AATL;AAaG;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAXJ;AAYI;EACC,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EAEA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAZL;AAoBI;EACC,cAAA;EACA,gCAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAlBL;AAoBI;EACC,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAlBL;AAsBG;EACC,mBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EAEA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AArBJ;AA2BE;EACC,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;AAzBH;AA6BG;EACC,mDAAA;EACA,wCAAA;EACA,0CAAA;EACA,eAAA;AA3BJ;;AAiCA;EACC,yBAAA;EACA,gBAAA;EACA,WAAA;AA9BD;;AAgCA;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AA7BD;AA8BC;EACC,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBAAA;EACA,2BAAA;EACA,oCAAA;EAEA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AA7BF;AA+BE;EACC,iDAAA;EACA,wCAAA;EACA,qCAAA;EACA,wBAAA;EACA,oCAAA;AA7BH;;AAiCA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA9BD;;AAgCA;EACC,YAAA;EACA,WAAA;EACA,aAAA;AA7BD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:host {\n\tbackground: var(--background-default);\n}\n\n.wrapper {\n\tpadding: 24px 16px;\n\tpadding-bottom: 60px;\n\toverflow-x: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: transparent;\n\n\t.title {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 16px;\n\t\tmargin: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: capitalize;\n\n\t\ttext-align: start;\n\t\tpadding: 0px 0px 16px;\n\t}\n\tion-col {\n\t\tpadding: 0;\n\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: 6px;\n\t\t}\n\n\t\t.card-item {\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tbackground: white;\n\t\t\tborder: var(--outline-default);\n\t\t\tborder-radius: var(--radius-default);\n\n\t\t\theight: 100%;\n\t\t\tpadding: 8px;\n\n\t\t\t.default-img {\n\t\t\t\tpadding: 5px;\n\t\t\t\tobject-fit: contain !important;\n\t\t\t\tbackground-color: #fff;\n\t\t\t}\n\n\t\t\t.image-block {\n\t\t\t\theight: 60px;\n\t\t\t\taspect-ratio: 4 / 3;\n\t\t\t\tposition: relative;\n\t\t\t\tmargin-right: 16px;\n\n\t\t\t\t// &:has(.default_img) {\n\t\t\t\t// \tbackground-color: var(--ion-color-primary);\n\t\t\t\t// }\n\n\t\t\t\tion-img {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t}\n\t\t\t\t.plus {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 10px;\n\t\t\t\t\tright: 10px;\n\t\t\t\t\theight: 32px;\n\t\t\t\t\twidth: 32px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.info-block {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tflex-grow: 1;\n\t\t\t\tpadding-right: 5px;\n\t\t\t\t.name {\n\t\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tline-height: 19px;\n\t\t\t\t\tletter-spacing: 0.01em;\n\t\t\t\t\tmargin: 0 0 4px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tcolor: #1e1e1c;\n\n\t\t\t\t\tword-break: break-word;\n\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\n\t\t\t\t\t// @include mobile {\n\t\t\t\t\t// \tfont-size: 13px;\n\t\t\t\t\t// \t// height: 32px;\n\t\t\t\t\t// \toverflow: hidden;\n\t\t\t\t\t// }\n\t\t\t\t}\n\t\t\t\t.deposit_text {\n\t\t\t\t\tfont-size: 9px;\n\t\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\t\tcolor: var(--color-black);\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t\t.price {\n\t\t\t\t\tmargin: auto 0 10px;\n\t\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 21.8px;\n\t\t\t\t\tletter-spacing: 0.01em;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tcolor: #1e1e1c;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.button {\n\t\t\t\tbackground: #f5f5f5;\n\t\t\t\theight: 39px;\n\t\t\t\twidth: 84px;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tflex-shrink: 0;\n\n\t\t\t\tfont-family: AppFont;\n\t\t\t\tfont-size: 14px;\n\t\t\t\ttext-align: center;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tborder-radius: 3px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.selected {\n\t\t.checkmark {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 10px;\n\t\t\tleft: 10px;\n\t\t\tz-index: 10;\n\t\t\t--icon-color: var(--ion-color-primary);\n\t\t}\n\n\t\t.card-item {\n\t\t\t.button {\n\t\t\t\t--background: var(--ion-color-secondary) !important;\n\t\t\t\tbackground: var(--background) !important;\n\t\t\t\tcolor: var(--ion-color-secondary-contrast);\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.content_block {\n\theight: calc(100% - 74px);\n\toverflow-y: auto;\n\twidth: 100%;\n}\n.footer-btn {\n\tposition: fixed;\n\tbottom: 20px;\n\tleft: 0px;\n\tright: 0px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 0 16px;\n\tion-button {\n\t\twidth: 100%;\n\t\t--background: transparent;\n\t\tfont-family: AppFont;\n\t\tcolor: #1d1d1b !important;\n\t\tborder: 0.6px solid #aeaead;\n\t\tborder-radius: var(--radius-default);\n\n\t\tfont-size: 14px;\n\t\tline-height: 18.9px;\n\t\tletter-spacing: 0.03em;\n\t\ttext-align: center;\n\n\t\t&.selected {\n\t\t\t--background: var(--ion-color-primary) !important;\n\t\t\tbackground: var(--background) !important;\n\t\t\tborder: 0.6px solid var(--background);\n\t\t\tfont-family: AppFontBold;\n\t\t\tcolor: var(--color-white) !important;\n\t\t}\n\t}\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\ttext-align: left;\n\tpadding-top: 6px;\n}\n.checkmark {\n\theight: 18px;\n\twidth: 18px;\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
